var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"base-panel-section"},[_c('header',[_c('h4',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('div',{staticClass:"base-panel-section__toolbar"},[_vm._t("toolbar")],2)]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }